/* global.js */
(function () {
  'use strict';

  /* ---- Mobile navigation ---- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const navOverlay = document.querySelector('[data-nav-overlay]');
  const menuClose = document.querySelector('[data-menu-close]');

  function openMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    if (navOverlay) navOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    if (navOverlay) navOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (navOverlay) navOverlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  /* ---- Cart count bubble (kept in sync after AJAX cart changes) ---- */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---- Okno po pridani do kosiku ---- */
  const cartModal = document.querySelector('[data-cart-modal]');
  function openCartModal() {
    if (!cartModal) return;
    cartModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartModal() {
    if (!cartModal) return;
    cartModal.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (cartModal) {
    cartModal.querySelectorAll('[data-cart-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeCartModal);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCartModal(); });
  }

  /* ---- Product gallery ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    const mainImg = gallery.querySelector('[data-gallery-main]');
    const strip = gallery.querySelector('[data-thumbs]');
    const thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!thumbs.length) return;

    function activate(thumb) {
      if (!thumb) return;
      const src = thumb.getAttribute('data-src');
      if (mainImg && src) mainImg.src = src;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      // Doroluje pas na aktivni nahled — posouvame jen pas, ne stranku
      if (strip) {
        var tr = thumb.getBoundingClientRect();
        var sr = strip.getBoundingClientRect();
        if (tr.left < sr.left) { strip.scrollLeft -= (sr.left - tr.left); }
        else if (tr.right > sr.right) { strip.scrollLeft += (tr.right - sr.right); }
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { activate(thumb); });
    });

    // Listovani fotek prstem (swipe), sipkami na strance i na klavesnici — dokola bez konce
    function step(dir) {
      if (thumbs.length < 2) return;
      let i = -1;
      thumbs.forEach(function (t, n) { if (t.classList.contains('is-active')) i = n; });
      if (i < 0) i = 0;
      activate(thumbs[(i + dir + thumbs.length) % thumbs.length]);
    }

    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    const stage = gallery.querySelector('.product__media-main') || mainImg;
    if (stage) {
      let x0 = null, y0 = null, dragging = false;

      function drag(px) {
        if (!mainImg) return;
        mainImg.style.transition = 'none';
        mainImg.style.transform = 'translateX(' + px + 'px)';
      }
      function dropBack() {
        if (!mainImg) return;
        mainImg.style.transition = 'transform .18s ease';
        mainImg.style.transform = '';
      }

      stage.addEventListener('touchstart', function (e) {
        const t = e.changedTouches[0];
        x0 = t.clientX; y0 = t.clientY; dragging = false;
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (x0 === null) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - x0;
        const dy = t.clientY - y0;
        // Rozhodne se jen jednou: vodorovny tah = listovani, svisly = rolovani stranky
        if (!dragging && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) dragging = true;
        if (dragging) drag(dx * 0.4);
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - x0;
        const dy = t.clientY - y0;
        x0 = null; y0 = null; dragging = false;
        dropBack();
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
      }, { passive: true });
      stage.addEventListener('touchcancel', function () {
        x0 = null; y0 = null; dragging = false; dropBack();
      }, { passive: true });
      stage.setAttribute('tabindex', '0');
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      });
    }

  });

  /* ---- Vyber varianty: jedna rada na pocitaci, az tri na mobilu, zbytek pod "Zobrazit vice" ---- */
  document.querySelectorAll('[data-variant-group]').forEach(function (group) {
    var btn = group.querySelector('[data-variant-more]');
    var chips = Array.prototype.slice.call(group.querySelectorAll('.variant-option'));
    if (!btn || chips.length < 2) return;

    var expanded = false;

    function showAll() {
      chips.forEach(function (c) { c.classList.remove('is-extra'); });
      group.classList.remove('is-compact');
      btn.hidden = true;
      expanded = true;
    }

    // Na uzkem displeji snesou volby vic mista — nechame je az na tri radky
    function maxRows() {
      return window.matchMedia('(max-width: 749px)').matches ? 3 : 1;
    }

    // Kolik chipu se vejde do povoleneho poctu radek. Pocitame ze sirek, ne z offsetTop —
    // ten po zmene tridy vraci jeste stare rozlozeni a vysledek pak neodpovida.
    function fitCount() {
      var wrap = group.querySelector('.variant-options');
      if (!wrap) return chips.length;
      var styles = window.getComputedStyle(wrap);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var avail = wrap.getBoundingClientRect().width;
      var rows = maxRows();
      var row = 1, used = 0, n = 0;
      for (var i = 0; i < chips.length; i++) {
        var w = chips[i].getBoundingClientRect().width;
        var add = used === 0 ? w : gap + w;
        if (used + add > avail + 0.5) {
          // Radka je plna — pokud jeste nejaka zbyva, chip zacne novou
          if (row >= rows) break;
          row++;
          used = w;
        } else {
          used += add;
        }
        n++;
      }
      return n;
    }

    function selectedIndex() {
      for (var i = 0; i < chips.length; i++) {
        var input = chips[i].querySelector('input');
        if (input && input.checked) return i;
      }
      return 0;
    }

    function fit() {
      if (expanded) return;
      // base.css ma na chipech transition .16s — behem mereni ji vypneme,
      // jinak by rozmery po zmene tridy jeste chvili ukazovaly starou velikost
      group.classList.add('is-measuring');
      try {
        chips.forEach(function (c) { c.classList.remove('is-extra'); });
        group.classList.remove('is-compact');
        btn.hidden = true;

        if (fitCount() >= chips.length) return;

        // Nevejde se vse — zkusime chipy zmensit, at nemusi byt tlacitko kvuli par kouskum
        group.classList.add('is-compact');
        if (fitCount() >= chips.length) return;

        var n = fitCount();
        if (n < 1) n = 1;
        // Vybrana volba musi byt videt; kdyz by zapadla, radeji ukazeme vse
        if (selectedIndex() >= n) { showAll(); return; }

        chips.forEach(function (c, i) { c.classList.toggle('is-extra', i >= n); });
        btn.hidden = false;
        btn.textContent = 'Zobrazit více (' + (chips.length - n) + ')';
      } finally {
        group.classList.remove('is-measuring');
      }
    }

    // fonts.ready se splni driv, nez prohlizec prepocita rozlozeni s novym pismem,
    // proto merime az po dvou snimcich
    function refit() {
      requestAnimationFrame(function () { requestAnimationFrame(fit); });
    }

    btn.addEventListener('click', showAll);
    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('load', refit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
  });

  /* ---- Popis produktu: kazda sekce (vcetne pribehu) jako rozbalovacka ---- */
  document.querySelectorAll('[data-desc-accordion]').forEach(function (rte) {
    var heads = Array.prototype.slice.call(rte.children).filter(function (n) { return n.tagName === 'H3'; });
    if (!heads.length) return;
    heads.forEach(function (h) {
      var body = [];
      var n = h.nextElementSibling;
      while (n && n.tagName !== 'H3') { body.push(n); n = n.nextElementSibling; }
      var details = document.createElement('details');
      details.className = 'product__acc';
      var summary = document.createElement('summary');
      summary.className = 'product__acc-head';
      summary.textContent = h.textContent;
      details.appendChild(summary);
      var wrap = document.createElement('div');
      wrap.className = 'product__acc-body';
      body.forEach(function (el) { wrap.appendChild(el); });
      details.appendChild(wrap);
      h.replaceWith(details);
    });
  });

  /* ---- Product description "show more" ---- */
  document.querySelectorAll('[data-desc-wrap]').forEach(function (wrap) {
    var desc = wrap.querySelector('[data-desc]');
    var btn = wrap.querySelector('[data-desc-toggle]');
    if (!desc || !btn) return;
    var moreEl = btn.querySelector('[data-desc-more]');
    var lessEl = btn.querySelector('[data-desc-less]');
    desc.classList.add('is-clamped');
    function overflowing() { return desc.scrollHeight - 2 > desc.clientHeight; }
    if (overflowing()) {
      btn.hidden = false;
    } else {
      desc.classList.remove('is-clamped');
    }
    btn.addEventListener('click', function () {
      var clamped = desc.classList.toggle('is-clamped');
      btn.setAttribute('aria-expanded', String(!clamped));
      if (moreEl) moreEl.hidden = !clamped;
      if (lessEl) lessEl.hidden = clamped;
    });
  });

  /* ---- Quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const step = parseInt(btn.getAttribute('data-qty-btn'), 10);
        let val = parseInt(input.value, 10) || 1;
        val = Math.max(1, val + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (wrap.hasAttribute('data-qty-autosubmit')) {
          const form = input.closest('form');
          if (form) {
            const submitter = form.querySelector('button[name="update"]') || undefined;
            if (form.requestSubmit) { form.requestSubmit(submitter); } else { form.submit(); }
          }
        }
      });
    });
  });

  /* ---- Variant selection + add to cart (AJAX — page never navigates away, shopping is not interrupted) ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    const dataEl = form.querySelector('[data-variants-json]');
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = form.querySelector('[data-price]');
    const compareEl = form.querySelector('[data-price-compare]');
    const submitBtn = form.querySelector('[data-add-btn]');
    const moneyFormat = form.getAttribute('data-money-format') || '{{amount}}';
    const gallery = form.closest('[data-gallery]');
    const galleryMain = gallery ? gallery.querySelector('[data-gallery-main]') : null;
    const fallbackImage = galleryMain ? galleryMain.getAttribute('src') : null;
    const firstThumb = gallery ? gallery.querySelector('[data-gallery-thumb]') : null;
    const fallbackMediaId = firstThumb ? firstThumb.getAttribute('data-media-id') : null;

    function formatMoney(cents) {
      const value = (cents / 100).toLocaleString('cs-CZ', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
    }

    function currentSelections() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]:checked'),
        function (i) { return i.value; }
      );
    }

    function update() {
      const sel = currentSelections();
      const match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? submitBtn.getAttribute('data-label-default') : submitBtn.getAttribute('data-label-soldout');
      }
      if (gallery) {
        // Varianta bez vlastni fotky -> zpet na hlavni fotku produktu, at nezustane viset fotka predchozi barvy
        const nextSrc = match.image || fallbackImage;
        if (galleryMain && nextSrc) galleryMain.src = nextSrc;
        const activeId = (match.media_id !== null && match.media_id !== undefined) ? String(match.media_id) : fallbackMediaId;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', activeId !== null && t.getAttribute('data-media-id') === activeId);
        });
      }
    }

    form.querySelectorAll('[data-option-index]').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();

    // Přidání do košíku přes AJAX — stránka se nikam nepřesměruje, nákup může pokračovat dál
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!submitBtn || submitBtn.disabled) return;

      const defaultLabel = submitBtn.getAttribute('data-label-default');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Přidávám…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) {
            submitBtn.textContent = (result.data && result.data.description) || 'Nepodařilo se přidat';
            setTimeout(function () { submitBtn.disabled = false; submitBtn.textContent = defaultLabel; }, 2200);
            return;
          }
          submitBtn.textContent = 'Přidáno ✓';
          updateCartCount();
          openCartModal();
          setTimeout(function () { submitBtn.disabled = false; submitBtn.textContent = defaultLabel; }, 1600);
        })
        .catch(function () {
          submitBtn.textContent = 'Chyba, zkus to znovu';
          setTimeout(function () { submitBtn.disabled = false; submitBtn.textContent = defaultLabel; }, 2200);
        });
    });
  });

  /* ---- Info modals (on-page, no navigation) ---- */
  function closeInfoModals() {
    document.querySelectorAll('.info-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-info-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-info-open');
      var modal = document.querySelector('[data-info-modal="' + id + '"]');
      if (modal) { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-info-close]').forEach(function (el) {
    el.addEventListener('click', closeInfoModals);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeInfoModals(); });

  /* ---- Newsletter (demo, no backend in preview) ---- */
  document.querySelectorAll('[data-newsletter-demo]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-live') === 'true') return;
      e.preventDefault();
      form.innerHTML = '<p style="color:var(--color-in-stock);margin:0;">Díky! Ozveme se, jakmile spustíme.</p>';
    });
  });
})();
